<template>
  <div class="appstauber" style="padding: 0px;">
    <NavigationBar id="rulesNavigationBarId" ref="rulesNavigationBarRef">
      <template #center>
        <span data-testid="appstauber-title">Teamtip Benefits</span>
      </template>
    </NavigationBar>

    <!--
    <h1>Appstauber</h1>
    <div>{{ spmbgid }}</div>
    <p>{{ user }}</p>
    <p>{{ token }}</p>
    -->

    <div style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <div>
      <app-stauber data-tenant-id="49615126692626431" data-show-header="false" data-campaign-id="50793623977018880"> </app-stauber>
      <!--
        <app-stauber
          data-header-z-index="1000"
          data-show-header="false"
          :data-external-ids=this.externalIds
          data-tenant-id="49615126692626431"
          :data-data-layer=this.dataLayer>
        </app-stauber>
        -->
      </div>
    </div>
  </div>
</template>

<script>

import NavigationBar from '@/components/NavigationBar.vue'

export default {
  name: 'appstauber',
  components: { NavigationBar },
  mounted() {
    window.bgIsLoggedIn = this.bgIsLoggedIn
    window.bgRouterPush = this.bgRouterPush
    window.cmp_noscreen = true
  },
  computed: {
    dataLayer() {
      const SPORTS_TYPE_FOOTBALL = 1
      const SPORTS_TYPE_HANDBALL = 2
      const SPORTS_TYPE_HOCKEY = 3
      const SPORTS_TYPE_ICE_HOCKEY = 4
      const SPORTS_TYPE_OLYMPIA = 5
      const SPORTS_TYPE_NFL = 6
      const SPORTS_TYPE_DARTS = 7
      var sportsType = 'Fussball'
      const type = this.competition.sports_type
      if(type === SPORTS_TYPE_FOOTBALL) {
        sportsType = 'Fussball'
      } else if (type === SPORTS_TYPE_HANDBALL) {
        sportsType = 'Handball'
      } else if (type === SPORTS_TYPE_HOCKEY) {
        sportsType = 'Hockey'
      } else if (type === SPORTS_TYPE_ICE_HOCKEY) {
        sportsType = 'Eishockey'
      } else if (type === SPORTS_TYPE_OLYMPIA) {
        sportsType = 'Olympia'
      } else if (type === SPORTS_TYPE_NFL) {
        sportsType = 'American Football'
      } else if (type === SPORTS_TYPE_DARTS) {
        sportsType = 'Darts'
      }
      const data = {
        sport: sportsType,
        locale: navigator.language,
        locationCountry: '' + this.geoData.Iso,
        uri: '/appstauber',
        userIsAdmin: '' + (this.betgame.fk_user === this.user.id),
        userIsMinor: '' + !this.user.isadult,
        isTenantAdmin: this.isSPMUser()
      }
      return JSON.stringify(data)
    },
    externalIds() {
      const data = {
        bid: '' + this.betgame.id,
        uid: '' + this.user.id,
      }
      return JSON.stringify(data)
    },
    geoData() {
      return JSON.parse(localStorage.getItem('geoData'))
    },
    competition() {
      return JSON.parse(localStorage.getItem('competition'))
    },
    betgame () {
      return JSON.parse(localStorage.getItem('betgame'))
    },
    user () {
      return JSON.parse(localStorage.getItem('user'))
    }
  },
  methods: {
    isSPMUser () {
      if(!this.user || !this.user.email) {
        return false
      }
      if(this.user.email.includes('appstoreconnect')) {
        return false
      }
      return this.user.email.includes('@spm.de') || this.user.email.includes('@sportplatz-media.com') ||
        this.user.email.includes('@spm.spm') || this.user.email.includes('hellmann.hamburg') ||
        this.user.email.includes('@fussifreunde.de') || this.user.email.includes('@merten-hellmann.de') ||
        this.user.email.includes('@marcelhager.de') || this.user.email.includes('niklas.fahrenholz@web.de') ||
        this.user.email.includes('philippreddigau+teamtip@googlemail.com')
    },
    bgIsLoggedIn(data) {
      return true
    },
    bgRouterPush(path) {
      window.location.href = 'https://teamtip.net/'
    }
  }
}
</script>

<style>
@media (min-width: 1024px) {
  .appstauber {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}
div {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
